import { FC } from 'react';

import { ICartRewardsDropdown, IRewardsDropdown } from './types';

export const RewardsDropdown = (() => null) as FC<IRewardsDropdown>;

export const CartRewardDropdown = (() => null) as FC<ICartRewardsDropdown>;
